var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcCheckArrowBlue = function SvgIcCheckArrowBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76493 13.0075C6.59826 13.0075 6.4316 12.9342 6.32493 12.8008L2.92493 8.64748C2.72493 8.40748 2.76493 8.04748 3.00493 7.84748C3.24493 7.64748 3.60493 7.68748 3.80493 7.92748L6.7116 11.4808L12.0249 3.19415C12.1983 2.93415 12.5449 2.85415 12.8116 3.02082C13.0783 3.18748 13.1516 3.54082 12.9849 3.80082L7.2516 12.7408C7.14493 12.9008 6.97826 12.9942 6.79826 13.0075C6.7916 13.0075 6.77826 13.0075 6.76493 13.0075Z",
    fill: "#286DF0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCheckArrowBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_check_arrow_blue.33fe47f5.svg";
export { ForwardRef as ReactComponent };